export const SLOT_LABEL_FORMAT = "HH:mm";
export const DAY_HEADER_FORMAT = "DD ddd";
export const MILLISECONDS_IN_PER_HOUR = 30 * 60 * 1000;
export const MILLISECONDS_IN_HOUR = 60 * 60 * 1000;
export const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
